import { ratio } from '../calculators/ratio'
import { countConversationsAssigned } from '../queries/countConversationsAssigned'
import { countConversationsResolved } from '../queries/countConversationsResolved'

export const conversationsAssignedResolvedRatioGauge = {
  calculate: ratio,
  queries: [countConversationsResolved, countConversationsAssigned],
  title: 'Assigned/Resolved Conversations',
}
